import {
    LOAD_CLASSES,
    LOAD_USER_CLASSES,
    LOAD_CLASS_SYLLABUS,
    ENROLL_TO_CLASS,
    UPDATE_DAY_CARD,
    UPDATE_NOTIFICATIONS_CARD,
    SET_ERRORS,
    CLEAR_ERRORS,
    LOADING_UI, 
    LOADING_DATA, 
    SET_CLASS, 
    CLOSE_ENROLL_DIALOG,
    LOAD_NOTIFICATIONS, 
    LOAD_MILESTONES,
    LOAD_CHAT_GROUP,
    LOAD_AUTOPILOT_GROUP,
    GET_SURVEY_STATUS
} from '../types';
import axios from 'axios';

export const closeEnrollDialog = () => (dispatch) => {
    dispatch({type: CLOSE_ENROLL_DIALOG });
};

// Get all classes (no authentication)
export const getClasses = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get('/api/classes')
        .then((res) => {
            dispatch({
                type: LOAD_CLASSES,
                payload: res.data
            });
        })
        .catch((err) => {
            dispatch({
                type: LOAD_CLASSES,
                payload: []
            });
        });
};

// Get user classes (authentication required)
export const getUserClasses = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get(`/api/user/classes`)
        .then((res) => {
            dispatch({
                type: LOAD_USER_CLASSES,
                payload: res.data
            });
            dispatch(clearErrors());
        })
        .catch((err) => console.log(err));
};


export const viewSyllabus = (programId, history) => (dispatch) => {
    dispatch({ type: SET_CLASS, payload: programId})
    // On-click of view syllabus reroute to the curriculum's page
    history.push(`/curriculum/${programId}`)
};

// Get class
export const getClass = (programId) => (dispatch) => {
    dispatch({ type: LOADING_DATA });
    axios
        .get(`/api/user/class/${programId}`)
        .then((res) => {
            dispatch({
                type: LOAD_CLASS_SYLLABUS,
                payload: res.data,
                programId: programId
            });
            dispatch(clearErrors());
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        });
};

// Enroll to a class
export const enrollUserToClass = (newClass) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .post('/api/enroll', newClass)
        .then((res) => {
            dispatch({
                type: ENROLL_TO_CLASS,
                payload: newClass.classId // TODO: this is the key for backend; change later
            });
            dispatch(clearErrors());
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        });
};

// Update a day card
export const updateDayCard = (updateProgress) => (dispatch) => {
    axios
        .put(`/api/user/class`, updateProgress)
        .then((res) => {
            dispatch({
                type: UPDATE_DAY_CARD,
                payload: res.data,
                request: updateProgress // contains classId, dayId, taskNumber, isDone
            });
        })
        .catch((err) => console.log(err));
};

export const updateNotificationCard = (updateIsRead) => (dispatch) => {
    axios
        .post(`/api/notifications`, updateIsRead)
        .then((res) => {
            dispatch({
                type: UPDATE_NOTIFICATIONS_CARD,
                payload: res.data,
                request: updateIsRead // contains dayId, isRead
            });
        })
        .catch((err) => console.log(err));
}

export const clearErrors = () => (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
};

export const getNotifications = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get(`/api/notifications`)
        .then((res) => {
            dispatch({
                type: LOAD_NOTIFICATIONS,
                payload: res.data
            });
            dispatch(clearErrors());
        })
        .catch((err) => console.log(err));
};

export const getProgressMilestone = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get(`/api/getMilestone`)
        .then((res) => {
            dispatch({
                type: LOAD_MILESTONES,
                payload: res.data
            });
            dispatch(clearErrors());
        })
        .catch((err) => console.log(err));
}

export const getAutoPilotGroup = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get(`/api/user/autoPilotGroup`)
        .then( (res) => {
            dispatch({
                type: LOAD_AUTOPILOT_GROUP, 
                payload: res.data.auto_pilot_group
            });
        })
        .catch((err) => console.log(err));
}

export const getGroupLink = (username) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get(`/api/connect`)
        .then((res) => {
            dispatch({
                type: LOAD_CHAT_GROUP,
                payload: res.data
            });
            dispatch(clearErrors());
        })
        .catch((err) => console.log(err));
};

export const getSurveyStatus = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get(`/api/validateFormSubmission`)
        .then((res) => {
            dispatch({
                type: GET_SURVEY_STATUS,
                payload: res.data.isValid
            });
            dispatch(clearErrors());
        })
        .catch((err) => console.log(err));
};
